import type { GoogleAdsPlaceholder_GeneralSize } from "@motain/xpa-proto-files-web/lib/types/google_ads_placeholder";

export function mapProtoResolutionToGPTResolution(
  size: GoogleAdsPlaceholder_GeneralSize,
): [number, number] {
  return [size.minWidth, size.minHeight];
}
